<template>
  <Header title="Our Products" />
  <PeopleList title="" :people="products" />
</template>

<script>
import PeopleList from "../../components/layouts/PeopleList.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";

const products = [
  {
    name: "U104",
    role: "Battery‐powered Asset Tracking Device",
    imageUrl: "/img/U100.png",
    bio: "Whether you are monitoring shipments on a truck or railroad car, the location of construction trailer, a shipping container, air conditioning compressor, pallet of high‐value products or any other valuable asset, the U104 is the right solution for you.",
  },
  {
    name: "U204",
    role: "Solar Powered Asset Tracking Device ",
    imageUrl:
      "/img/U100.png",
    bio: "The U204 solar powered GPS tracker is great for dry-vans, construction/equipment/utility trailers and other assets that are more stationary then moving.",
  },
  {
    name: "U304",
    role: "Hard Wired GPS Tracker ",
    imageUrl:
      "/img/U300.png",
    bio: "The U304 tracker is designed for fleet management, insurance telematics, vehicle leasing, transportation/ trucking, and emergency response providers to optimize their mobile resources and improve their bottom line.",
	features: "External GPS / GLONASS Antenna, 4 Inputs / 2 Outputs, RFID Reader, Still Camera",
  },
  {
    name: "U404",
    role: "GPS Padlock ",
    imageUrl:
      "/img/U400.png",
    bio: "As the first line of defence protecting your property, the U404 is a robust High Security padlock designed for outdoor conditions. Moreover, it will inform you if and when a predefined event occurs that warrants your attention. Depending on your needs, you can define a variety of alerts and information you would like to receive.",
  },
  {
    name: "U504",
    role: "Plug & Play Tracker (OBD2 Port)",
    imageUrl:
      "/img/U500.png",
    bio: "The U504 was built for the Usage Based Insurance (UBI) telematics, and fleet management markets. Providing easy plug and play installation, the U504 is designed for passenger cars, light trucks, and service vans.",
  },
  {
    name: "U904",
    role: "GPS Dash Camera Tracker",
    imageUrl:
      "/img/U900.png",
    bio: "With two cameras (front and inward) recording video at 1080p, support for SD card with up to 128GB capacity. The U904 churns out crystal clear footage day or night for hours on end without needing to overlap old video. A G-sensor is built into the device to automatically record and lock footage in the instance of an accident.",
  },
  {
    name: "U1000",
    role: "Iridium Satellite Tracker",
    imageUrl:
      "/img/U1000.jpg",
    bio: "U1000 can be programmed to automatically switch between the Iridium and cellular networks based on a predefined set of conditions.It can send either a standard or a 256 bit AES encrypted GPS report at a pre programmed interval ranging from continuous to once every seven days.The interval can be changed remotely while the unit is in the field.",
  },
  {
    name: "U4004",
    role: "Yard Camera HD 720P Solar & Battery Power IP Yard Camera",
    imageUrl:
      "/img/U4000.jpg",
    bio: "This HD 720P Solar & Battery Power IP Camera equipped with IR double filter, which makes it get clear images both day and night. With night visibility up to 100m. You can use android/iOS mobile devices remote view anywhere anytime. The email alert function, motion detection function and waterproof function make it widely used in outdoor places.",
  },
];
export default {
  components: {
    Container,
    Header,
    PeopleList,
  },
  setup() {
    return { products };
  },
};
</script>
